import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { BaseTab } from '@/components/ui/Tab/BaseTab';
export const FlatTab = (props) => {
    const { activeValue, children, className = '', disabled, innerPadding = 'p-8', onChange, to, value, widthClassName = 'w-full md:w-[260px]', } = props;
    const customClass = {
        button: {
            active: clsx('text-primary font-bold'),
            disabled: clsx('opacity-50 hover:cursor-default pointer-events-none'),
            inactive: clsx('text-textGray font-normal'),
            normal: clsx('text-center', innerPadding),
        },
        tab: {
            active: clsx('bg-white', 'drop-shadow-md'),
            inactive: clsx('bg-light-gray'),
            normal: clsx('flex items-center justify-center', 'h-[60px]', 'rounded-t-md', 'overflow-hidden', className),
        },
    };
    return (_jsxs("div", Object.assign({ className: clsx('relative', widthClassName) }, { children: [activeValue === value && (_jsx("span", { className: clsx('display w-full h-[7px]', 'absolute   z-20 bottom-0 left-0', 'bg-white') })), _jsx(BaseTab, Object.assign({ activeValue: activeValue, classNames: customClass, disabled: disabled, onChange: onChange, to: to, value: value }, { children: children }))] })));
};
